import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type BoostCashFlowIconProps = CommonSvgProps

const BoostCashFlowIcon: React.FC<BoostCashFlowIconProps> = React.forwardRef<
  SVGSVGElement,
  BoostCashFlowIconProps
>((props, ref) => (
  <Svg viewBox="0 0 69 85" {...props} ref={ref} color="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.2449 44.7701C40.2449 46.5263 39.6361 48.0169 38.4185 49.2419C37.201 50.4669 35.4361 51.2094 33.1238 51.4696V55.1121H30.6068V51.5021C29.0925 51.3937 27.6601 51.101 26.3096 50.6241C24.959 50.1471 23.8847 49.54 23.0867 48.8028L24.4679 45.5181C25.2251 46.1686 26.1459 46.716 27.2304 47.1605C28.315 47.605 29.4404 47.8814 30.6068 47.9898V41.4855C29.1539 41.1169 27.9415 40.7104 26.9695 40.2659C25.9975 39.8214 25.1841 39.171 24.5293 38.3146C23.8745 37.4582 23.5471 36.3253 23.5471 34.9161C23.5471 33.1599 24.1507 31.6639 25.3581 30.4281C26.5654 29.1922 28.3149 28.4551 30.6068 28.2166V24.5416H33.1238V28.1515C34.2697 28.2166 35.39 28.4226 36.4848 28.7695C37.5796 29.1164 38.5362 29.5717 39.3547 30.1354L38.0963 33.4201C36.5411 32.4661 34.8836 31.8807 33.1238 31.6639V38.2333C34.5971 38.6019 35.8197 39.003 36.7917 39.4366C37.7637 39.8702 38.5822 40.5152 39.2473 41.3716C39.9123 42.228 40.2449 43.3609 40.2449 44.7701ZM27.5067 34.7209C27.5067 35.4364 27.7727 36.011 28.3047 36.4446C28.8368 36.8782 29.6041 37.2468 30.6068 37.5503V31.7615C29.5632 31.9349 28.7856 32.2818 28.274 32.8021C27.7625 33.3225 27.5067 33.9621 27.5067 34.7209ZM33.1238 47.9248C34.2083 47.7513 35.0115 47.4153 35.5333 46.9166C36.0551 46.4179 36.316 45.8 36.316 45.0628C36.316 44.3257 36.0397 43.7349 35.4872 43.2904C34.9347 42.8459 34.1469 42.4719 33.1238 42.1684V47.9248Z"
      fill="#53A2D9"
    />
    <mask
      id="mask0_1192_1936"
      style={{maskType: 'alpha'}}
      maskUnits="userSpaceOnUse"
      x="23"
      y="24"
      width="18"
      height="32"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.2449 44.7701C40.2449 46.5263 39.6361 48.0169 38.4185 49.2419C37.201 50.4669 35.4361 51.2094 33.1238 51.4696V55.1121H30.6068V51.5021C29.0925 51.3937 27.6601 51.101 26.3096 50.6241C24.959 50.1471 23.8847 49.54 23.0867 48.8028L24.4679 45.5181C25.2251 46.1686 26.1459 46.716 27.2304 47.1605C28.315 47.605 29.4404 47.8814 30.6068 47.9898V41.4855C29.1539 41.1169 27.9415 40.7104 26.9695 40.2659C25.9975 39.8214 25.1841 39.171 24.5293 38.3146C23.8745 37.4582 23.5471 36.3253 23.5471 34.9161C23.5471 33.1599 24.1507 31.6639 25.3581 30.4281C26.5654 29.1922 28.3149 28.4551 30.6068 28.2166V24.5416H33.1238V28.1515C34.2697 28.2166 35.39 28.4226 36.4848 28.7695C37.5796 29.1164 38.5362 29.5717 39.3547 30.1354L38.0963 33.4201C36.5411 32.4661 34.8836 31.8807 33.1238 31.6639V38.2333C34.5971 38.6019 35.8197 39.003 36.7917 39.4366C37.7637 39.8702 38.5822 40.5152 39.2473 41.3716C39.9123 42.228 40.2449 43.3609 40.2449 44.7701ZM27.5067 34.7209C27.5067 35.4364 27.7727 36.011 28.3047 36.4446C28.8368 36.8782 29.6041 37.2468 30.6068 37.5503V31.7615C29.5632 31.9349 28.7856 32.2818 28.274 32.8021C27.7625 33.3225 27.5067 33.9621 27.5067 34.7209ZM33.1238 47.9248C34.2083 47.7513 35.0115 47.4153 35.5333 46.9166C36.0551 46.4179 36.316 45.8 36.316 45.0628C36.316 44.3257 36.0397 43.7349 35.4872 43.2904C34.9347 42.8459 34.1469 42.4719 33.1238 42.1684V47.9248Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1192_1936)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5867 25.125C14.5867 24.0204 15.4821 23.125 16.5867 23.125H46.5867C47.6912 23.125 48.5867 24.0204 48.5867 25.125V55.125C48.5867 56.2296 47.6912 57.125 46.5867 57.125H16.5867C15.4821 57.125 14.5867 56.2296 14.5867 55.125V25.125Z"
        fill="#53A2D9"
      />
    </g>
    <path
      d="M55.264 25.6667L66.9307 13.8333L55.264 2"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.9307 13.8333H31.9307"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6667 82.349L2 70.5157L13.6667 58.6824"
      stroke="#7BB835"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37 70.5157H2"
      stroke="#7BB835"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
))

BoostCashFlowIcon.propTypes = commonPropTypes
BoostCashFlowIcon.defaultProps = commonDefaultProps

export default BoostCashFlowIcon
